import { render, staticRenderFns } from "./IntegerValue.vue?vue&type=template&id=1a96050e&"
import script from "./IntegerValue.vue?vue&type=script&lang=js&"
export * from "./IntegerValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports